<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-form id="payment-form" @submit.prevent="submit" v-model="disable_pay" ref="admissionfeeform">
            <v-card v-if="stud_name != null" outlined dense class="box">
                <v-row dense>
                    <v-col col="6">
                        <v-chip class="ma-2" color="grey darken-1" outlined label> <v-icon left>mdi-account-circle-outline</v-icon> Student Name : {{ stud_name }} </v-chip>
                        
                        
                        <!--<v-chip class="ma-2" color="grey darken-1" outlined label>
              <v-icon left>mdi-alpha-g-circle-outline</v-icon>ID : {{ stud_id }}
            </v-chip> -->
                        <v-chip class="ma-2" color="grey darken-1" outlined label> <v-icon left>mdi-alpha-s-circle-outline</v-icon> Standard : {{ std }} </v-chip>
                        <v-chip class="ma-2" color="red darken-1" outlined label>Quota : {{ quota }}</v-chip>
                    </v-col>

                    <v-col col="6">
                        <v-chip class="ma-2" color="success" outlined pill>
                            Total Fees: {{ fees_master.total_fees_amount }}
                            <v-icon right>mdi-currency-inr</v-icon>
                        </v-chip>
                        <v-chip class="ma-2" color="primary" outlined pill>
                            Paid: {{ stud_fees.paid_till_now }}
                            <v-icon right>mdi-currency-inr</v-icon>
                        </v-chip>
                        <v-chip class="ma-2" color="error" outlined pill>
                            Refunded: {{ stud_fees.refunded_amount }}
                            <v-icon right>mdi-currency-inr</v-icon>
                        </v-chip>
                        <v-chip class="ma-2" color="warning" outlined pill>
                            Balance:{{ stud_fees.balance }}
                            <v-icon right>mdi-currency-inr</v-icon>
                        </v-chip>
                    </v-col>
                </v-row>

                <v-row justify="center" dense>
                    <v-col col="11">
                        <v-expansion-panels accordion focusable>
                            <v-expansion-panel>
                                <v-expansion-panel-header outlined class="subtitle-1 font-weight-medium toolbar">
                                    Previous Reciept
                                    <template v-slot:actions>
                                        <v-btn fab small><v-icon color="primary">$expand</v-icon> </v-btn>
                                    </template>
                                </v-expansion-panel-header>

                                <v-expansion-panel-content class="box">
                                    <template>
                                        <v-simple-table class="mytable elevation-1" dense>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">Sr No</th>
                                                        <th class="text-left">Reciept No</th>
                                                        <th class="text-left">Amount</th>
                                                        <th class="text-left">Payment Mode</th>
                                                        <th class="text-left">Date</th>
                                                        <th class="text-left">Remark</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="item in stud_receipts" :key="item.srno">
                                                        <td>{{ item.srno }}</td>
                                                        <td>
                                                            <v-btn class="ma-2" tile outlined color="success" @click="callAdmissionFeesReciept(item.receipt_id)" title="View Reciept">
                                                                <v-icon left>mdi-file-eye</v-icon> {{ item.receipt_no }}
                                                            </v-btn>
                                                        </td>
                                                        <td>{{ item.amount }}</td>
                                                        <td>Mode</td>
                                                        <td>{{ item.receipt_date }}</td>
                                                        <td>{{ item.remark }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </template>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                </v-row>
                <v-row dense v-if="stud_receipts == null">
                    <v-col col="6">
                        <v-alert style="width: 40%; margin: 0 auto;" dismissible dense outlined type="warning">
                            <span class="subtitle-1 font-weight-medium"> No Previous Reciept</span>
                        </v-alert>
                    </v-col>
                </v-row>
                <!-----------/. end Previous Recipt ----------------->

                <v-row justify="center" dense>
                    <v-col col="11">
                        <v-expansion-panels accordion focusable>
                            <v-expansion-panel>
                                <v-expansion-panel-header outlined class="subtitle-1 font-weight-medium toolbar">
                                    Payment Schedule
                                    <template v-slot:actions>
                                        <v-btn fab small><v-icon color="primary">$expand</v-icon> </v-btn>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="box">
                                    <template>
                                        <v-simple-table class="mytable elevation-1" dense>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">Sr.No</th>
                                                        <th class="text-left">Payment Stage</th>
                                                        <th class="text-left">Amount Payable</th>
                                                        <th class="text-left">Deadline</th>
                                                        <th class="text-left">Concession</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in payment_schedules" :key="index">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ item.stage }}</td>
                                                        <td>{{ item.amount }}</td>
                                                        <td>{{ item.deadline }}</td>
                                                        <td>{{ item.concession }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </template>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                </v-row>

                <v-row dense v-if="payment_schedules == null">
                    <v-col col="6">
                        <v-alert style="width: 40%; margin: 0 auto;" dismissible dense outlined type="warning">
                            <span class="subtitle-1 font-weight-medium"> No Payment Schedule</span>
                        </v-alert>
                    </v-col>
                </v-row>
                <!-----------/. end Previous Recipt ----------------->
            </v-card>
            <br />
            <v-card v-if="stud_name != null" class="box">
                <input type="hidden" v-model="stud_id" name="stud_id" />
                <input type="hidden" v-model="fees_master.id" name="fees_master_id" />
                <v-card-text>
                    <!-- inputs:{{inputs}} -->
                    <v-btn class="button mt-6" @click="addRow" style="float: right;">Add Mode</v-btn>
                    <br />
                    <v-row v-for="(input, index) in inputs" :key="index" style="float: both;">
                        <v-col cols="2">
                            <v-combobox dense rounded required :items="mode_list" item-text="name" v-model="input.mode" label="Payment Mode" name="mode" outlined />
                        </v-col>

                        <v-col cols="2">
                            <div class="datepicker-div">
                                <label>DD/Cheque Date </label>
                                <datepicker class="datepicker" :format="customFormatter" placeholder="dd/mm/yyyy" name="mode_date" dense></datepicker>
                            </div>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field outlined rounded label="Transaction ID" v-model="input.trans_id" placeholder="123" name="trans_id" dense></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-combobox dense rounded required :items="bank_list" v-model="input.bank" label="Bank" name="bank" outlined />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                label="* Mode Amount"
                                v-model="input.amount"
                                placeholder="123"
                                @change="calReceiptAmount"
                                :rules="[v => !!v || 'Mode amount is required']"
                                type="number"
                                name="mode_amount"
                                dense
                                rounded
                                outlined
                                hint="Mode amount is required"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-btn text icon color="grey lighten-1" @click="deleteRow(index)"><v-icon> mdi-delete</v-icon></v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="2">
                            <v-text-field rounded label="Receipt Amount" placeholder="20000" name="receipt_amount" v-model="receipt_amount" :rules="[v => !!v || 'Amount is required']" required readonly dense filled outlined></v-text-field>
                        </v-col>
                        <v-col cols="7">
                            <v-text-field rounded label="Receipt Remark" placeholder="Full Payment" name="receipt_remark" dense outlined></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <div class="datepicker-div">
                                <label>Receipt Date </label>
                                <datepicker class="datepicker" style="" v-model="receipt_date" :format="customFormatter" placeholder="dd/mm/yyyy" name="receipt_date"></datepicker>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="2">
                            <v-text-field rounded label="Consession Amount" placeholder="5000" name="concession_amount" type="number" dense value="0" outlined></v-text-field>
                        </v-col>
                        <v-col cols="7">
                            <v-text-field rounded label="Consession remark" placeholder="Mention reason for concession" name="concession_remark" dense outlined></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card v-if="stud_name != null">
                   <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <!-- <v-row justify="center" dense>
                        <v-col sm="3">
                            <h3>Fees Component</h3>
                        </v-col>
                    </v-row> -->
                    <v-row class="font-weight-bold" justify="center" dense>
                        <v-col sm="3" class="toolbar">Component</v-col>
                        <v-col sm="2" class="toolbar">Actual</v-col>
                        <v-col sm="2" class="toolbar">Paid</v-col>
                        <v-col sm="2" class="toolbar">Balance</v-col>
                        <v-col sm="2" class="toolbar">
                            Pay Now
                        </v-col>
                    </v-row>
                    <v-row v-for="comp in component" justify="center" :key="comp.id" dense>
                        <v-col sm="3">{{ comp.name }}</v-col>
                        <v-col sm="2">{{ comp.amount }}</v-col>
                        <v-col sm="2">{{ comp.paid_amount }}</v-col>
                        <v-col sm="2">{{ comp.balance_amount }}</v-col>
                        <v-col sm="2">
                            <input class="input" type="number" @change="calCompTotal" v-model="comp.current_amount" :name="comp.id" :rules="[v => !!v || 'Required' || v >= 0]" />
                        </v-col>
                    </v-row>
                    <hr />
                    <v-row dense justify="center" class="font-weight-bold">
                        <v-col sm="3" class="toolbar">{{ comp_total.name }}</v-col>
                        <v-col sm="2" class="toolbar">{{ comp_total.amount }}</v-col>
                        <v-col sm="2" class="toolbar">{{ comp_total.paid_amount }}</v-col>
                        <v-col sm="2" class="toolbar">{{ comp_total.balance_amount }}</v-col>
                        <v-col sm="2" class="toolbar">
                            {{ comp_total.current_amount }}
                        </v-col>
                    </v-row>
                </v-col>
                </v-card>
                <v-card-actions>
                    <v-spacer> </v-spacer>
                    <v-btn @click="submit" rounded :disabled="!disable_pay" class="button" :color="disable_pay ? '' : 'grey lighten-1'">Pay</v-btn>
                    <v-spacer> </v-spacer>
                </v-card-actions>
            </v-card>
        </v-form>
    </div>
</template>
<script>
    import axios from "axios";
    import Datepicker from "vuejs-datepicker";
    import moment from "moment";
    export default {
        components: {
            Datepicker,
        },
        data: () => ({
            receipt_date: new Date(),
            stud_id: null,
            stud_name: null,
            std: null,
            fees_master: null,
            component: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            stud_fees: {
                paid_till_now: 0,
                refunded_amount: 0,
                balance: 0,
            },
            stud_receipts: null,
            payment_schedules: null,
            inputs: [{ mode: "Cash", bank: "", trans_id: "", amount: 0, mode_date: [] }],
            mode: null,
            mode_list: null,
            bank: null,
            bank_list: null,
            receipt_amount: 0,
            comp_total: null,
            disable_pay: true,
        }),
        watch: {
            "$store.state.data_for_fees": function () {
                this.getStudFeesData();
            },
            receipt_amount() {
                this.checkPay();
            },
        },
        methods: {
            customFormatter(date) {
                return moment(date).format("DD/MM/YYYY");
            },
            checkPay() {
                if (this.receipt_amount == this.comp_total.current_amount) {
                    this.disable_pay = true;
                } else {
                    this.disable_pay = false;
                }
            },
            calCompTotal() {
                this.comp_total.current_amount = 0;
                for (var i = 0; i < this.component.length; i++) {
                    this.comp_total.current_amount += parseFloat(this.component[i].current_amount);
                }
                this.checkPay();
            },
            calReceiptAmount() {
                this.receipt_amount = 0;
                for (var i = 0; i < this.inputs.length; i++) {
                    this.receipt_amount += parseFloat(this.inputs[i].amount);
                }
                var pay_comp_now = this.receipt_amount;
                for (var i = 0; i < this.component.length; i++) {
                    console.log(this.component[i].balance_amount);
                    this.component[i].current_amount = 0;
                    if (pay_comp_now >= this.component[i].balance_amount) {
                        this.component[i].current_amount = this.component[i].balance_amount;
                        pay_comp_now = pay_comp_now - this.component[i].balance_amount;
                    } else {
                        this.component[i].current_amount = pay_comp_now;
                        pay_comp_now = 0;
                        //break
                    }
                    this.comp_total.current_amount += this.component[i].current_amount;
                }
                if (pay_comp_now > 0) {
                    for (var i = 0; i < this.component.length; i++) {
                        if (this.component[i].name == "Excess") {
                            this.component[i].current_amount = pay_comp_now;
                            break;
                        }
                    }
                }
                this.calCompTotal();
                // for(var i=0;i<this.comp_total.length;i++){

                // }
            },
            callAdmissionFeesReciept(receipt_id) {
                this.$store.commit("setreceipt_id", receipt_id);
                this.$router.push({ name: "admission-fees-receipt" });
                return;
            },
            submit: function (e) {
                this.loader = false;
                var form = document.getElementById("payment-form");
                var formData = new FormData(form);
                axios
                    .post("/feesPayment/saveAdmissionFees", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.status == "SUCCESS") {
                                this.$store.commit("setreceipt_id", res.data.receipt_id);
                                this.$router.push({ name: "admission-fees-receipt" });
                                return;
                            } else {
                                alert(res.data.status_reason);
                            }
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            addRow() {
                this.inputs.push({
                    mode: "Cash",
                    bank: "",
                    trans_id: "",
                    amount: 0,
                    mode_date: { value: "" },
                });
            },
            deleteRow(index) {
                this.inputs.splice(index, 1);
                this.calReceiptAmount();
            },
            getStudFeesData() {
                //api-2
                //flush data
                this.stud_name = null;
                this.std = null;
                this.fees_master = null;
                this.component = null;
                this.inputs = [];
                this.inputs.push({
                    mode: "Cash",
                    bank: "",
                    trans_id: "",
                    amount: 0,
                    mode_date: { value: "" },
                });
                this.receipt_amount = 0;
                //ends
                const formData = this.$store.getters.data_for_fees;
                axios
                    .post("/feesPayment/getStudFeesData", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.status == "SUCCESS") {
                                this.stud_id = res.data.stud_id;
                                this.stud_name = res.data.stud_name;
                                this.std = res.data.std;
                                this.quota = res.data.quota
                                this.fees_master = res.data.fees_master;
                                this.component = res.data.component;
                                this.stud_fees = res.data.stud_fees;
                                this.stud_receipts = res.data.stud_receipts;
                                this.payment_schedules = res.data.payment_schedules;
                                this.mode_list = res.data.mode_list;
                                this.mode = this.mode_list[0];
                                this.bank_list = res.data.bank_list;
                                this.comp_total = res.data.comp_total;
                            } else {
                                this.showSnackbar("#b71c1c", res.data.status_reason);
                            }
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.proceed_btn_load = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.getStudFeesData();
        },
    };
</script>
<style scoped>
    .datepicker-div {
        margin-top: -20px;
    }
    .datepicker-div label {
        color: #00000099;
        font-size: 12px;
        position: relative;
        top: 4px;
    }
    .datepicker,
    .input {
        border: 1px solid #dddddd;
        padding: 7px 0 7px;
        border-radius: 4px;
        width: 100%;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
    }
</style>
